import { render, staticRenderFns } from "./InvertingThePyramidArticle.vue?vue&type=template&id=6d019282&"
import script from "./InvertingThePyramidArticle.vue?vue&type=script&lang=js&"
export * from "./InvertingThePyramidArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports